<template>
  <ul class="tw:flex tw:flex-row tw:w-full tw:my-6 tw:gap-x-2" data-testid="hotel-offers-initial-filter">
    <li v-for="category in filteringCategories" :key="category.value">
      <button
        @click="selectFilter(category.value)"
        :class="
          selectedFilter === category.value
            ? 'tw:border-blue-300 tw:bg-blue-300 tw:text-blue-800'
            : 'tw:bg-transparent tw:border-gray-300'
        "
        :data-testid="`${dataTestIdLocation}-hotel-offers-filter-${category.value}-button`"
        class="tw:text-xs tw:font-bold tw:py-3 tw:px-6 tw:rounded-full tw:border tw:leading-3 tw:flex tw:items-center tw:hover:cursor-pointer"
      >
        <span
          v-if="['perks', 'guest_experience'].includes(category.value) && selectedFilter !== category.value"
          aria-hidden="true"
          class="tw:inline-block tw:mr-1 tw:rounded-full tw:h-[7px] tw:w-[7px] tw:bg-red-700"
        ></span>
        <span>
          {{ $t(category.label) }}
        </span>
      </button>
    </li>
  </ul>
</template>
<script setup>

defineProps({
  filteringCategories: Array,
  selectedFilter: String,
  dataTestIdLocation: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['selectFilter'])
const selectFilter = category => emit('selectFilter', category)
</script>
